import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const ProRegOnboardModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleRegister = () => {
    onClose();
    navigate("/realtor-onbaord"); // Adjust route if needed
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 600, color: "#2563eb" }}>
        Become a Professional
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 1 }}>
          You need to register as a professional before you can subscribe to this plan.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Professional access enables you to list properties, use marketing tools,
          and access exclusive features.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ color: "#a855f7" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleRegister}
          sx={{
            backgroundColor: "#2563eb",
            "&:hover": {
              backgroundColor: "#1d4ed8",
            },
          }}
        >
          Register Now
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ProRegOnboardModal;
